/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import apiClient from "../../../../../apiClient";

function WhyChooseUs({ onClose, onSuccess, onFailed }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const [formData, setFormData] = useState({
    question: "",
    answer: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic here
    try {
      console.log("Form data submitted:", formData);
      const response = await apiClient.post("/admin/why-choose-us", formData);
      if (response.status === 200) {
        if (response.data.status === "success") {
          onSuccess();
          onClose();
        } else if (response.data.status === "error") {
          console.error("Error creating faq:", response.data.message);
          onFailed(response.data.message);
          onClose();
        }
      }
    } catch (error) {
      console.error("Error creating faq:", error);
    }
  };

  return (
    <Card id="add-why-choose-us">
      <MDBox p={4}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} lg={12}>
            <Grid item xs={5}>
              <TextField
                fullWidth
                label="Questions"
                name="question"
                value={formData.question}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={5}>
              <TextField
                fullWidth
                label="Answer"
                name="answer"
                value={formData.answer}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={2}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ color: "#fff" }}
              >
                <icon>+</icon>Add
              </Button>
            </Grid>
          </Grid>
        </form>
      </MDBox>
    </Card>
  );
}

export default WhyChooseUs;
